import * as RadioGroup from "@radix-ui/react-radio-group";
import { styled } from "@vitality-ds/system";
import BaseRadioButtonStyles from "./styles/BaseRadioButton.styles";
import BaseRadioButtonContainerStyles from "./styles/BaseRadioButtonContainer.styles";
import BaseRadioIndicatorStyles from "./styles/BaseRadioIndicator.styles";
import BaseRadioLabelStyles from "./styles/BaseRadioLabel.styles";
export var BaseRadioButton = styled(RadioGroup.Item, BaseRadioButtonStyles);
export var BaseRadioIndicator = styled(RadioGroup.Indicator, BaseRadioIndicatorStyles);
export var BaseRadioLabel = styled("label", BaseRadioLabelStyles);
export var BaseRadioButtonContainer = styled("div", BaseRadioButtonContainerStyles);